<ng-container class="d-flex justify-content-between align-items-center">
  <div class="reset-form-wrapper position-relative h-100 d-flex justify-content-between flex-column">
    <div>
      <div class="mb-5" *ngIf="!is_passSucUpdated && selectedIndex !== '2'">
        <div class="fw-bolder text-center reset-title">{{is_from_verify_account ? 'Set' : 'Reset'}} Password</div>
        <!-- <small class="text-secondary">
          You can reset your password here.
        </small> -->
      </div>
      <p [innerHtml]="verify_otp_success_msg" *ngIf="verify_otp_success_msg != '' && selectedIndex != '2'"></p>
      <mat-tab-group [(selectedIndex)]="selectedIndex" class="reset-pass-tabs">
        <mat-tab disabled>
          <mat-form-field appearance="outline">
            <input [formControl]="reset_mobile_email" type="text" autocomplete="off" class="text-center" matInput placeholder="Please enter Email/Mobile" [disabled]="is_passReset" aria-label="Email address or mobile number">
            <mat-error>Mobile Number or Email Address is required</mat-error>
          </mat-form-field>
          <div class="mt-2 d-flex align-items-center justify-content-center flex-column">
            <small *ngIf="verify_otp_error_msg != ''" class="form-error-msg-text text-center" [innerHTML]="verify_otp_error_msg"></small>
            <button mat-flat-button *ngIf="!show_otp_filed && !is_passReset" color="primary" class="reset-password-btn" [style.margin-top]="verify_otp_error_msg != '' ? '1rem' : '0'" (click)="reset_mobile_email.invalid ? validateRstPassField() : getLoginDetails()">
              Reset My Password
            </button>
            <mat-icon *ngIf="is_passReset"><mat-spinner diameter="24"></mat-spinner></mat-icon>
          </div>
        </mat-tab>
        <mat-tab disabled>
          <mat-form-field appearance="outline">
            <input class="otp-input-field text-center" [formControl]="otp_ctrl" autocomplete="off" matInput placeholder="Enter Verification Code" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)" (keypress)="validateOTP($event)" (paste)="(false)" min="0" type="text" inputmode="numeric" onwheel="return false" aria-label="Enter Verification Code">
            <mat-error>Please enter valid Verification Code</mat-error>
          </mat-form-field>
          <div class="d-flex justify-content-center align-items-center flex-column" [style.margin-top]="otp_error_msg != '' ? '0' : 'mt-3'">
            <small *ngIf="otp_error_msg != ''" class="form-error-msg-text" [innerHTML]="otp_error_msg"></small>
            <button mat-flat-button *ngIf="show_otp_filed && !is_verifyingOtp" color="primary" class="verify-otp-btn" [style.margin-top]="otp_error_msg != '' ? '1rem' : '0'" (click)="verifyOtp()">Verify Code</button>
            <mat-icon *ngIf="is_verifyingOtp"><mat-spinner diameter="24"></mat-spinner></mat-icon>
            <div *ngIf="show_otp_filed" class="mt-3">
              <button mat-button class="resend-otp-btn" (click)="forgotPassword()" [disabled]="is_verifyingOtp || is_passReset" [disableRipple]="true">
                Resend Verification Code {{countdown >= 0 ? countdown : ''}}
              </button>
            </div>
          </div>
        </mat-tab>
        <mat-tab disabled>
          <ng-container *ngIf="!is_passSucUpdated; else successMsg">
            <form [formGroup]="passConfirmationForm">
              <mat-form-field appearance="outline">
                <input formControlName="new_password" autocomplete="new-password" [type]="is_new_pass_type_password ? 'text' : 'password'" matInput [disabled]="is_passUpdating" placeholder="New Password" aria-label="New Password">
                <mat-icon class="password-visbility-icon" matSuffix style="cursor: pointer" (click)="is_new_pass_type_password = !is_new_pass_type_password;">{{
                  is_new_pass_type_password ?
                  'visibility_off' :
                  'visibility'}}</mat-icon>
                <mat-error *ngIf="passConfirmationForm.controls['new_password'].invalid && (passConfirmationForm.controls['new_password'].dirty || passConfirmationForm.controls['new_password'].touched)">
                  <div *ngIf="passConfirmationForm.controls['new_password'].errors?.required">Enter new Password</div>
                  <div *ngIf="!passConfirmationForm.controls['new_password'].errors?.required && !passConfirmationForm.controls['new_password'].errors?.maxlength">{{getFieldErrorMsg('new_password')}}</div>
                  <div *ngIf="passConfirmationForm.controls['new_password'].errors?.maxlength">Password should be less than 20 characters</div>
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <input formControlName="confirm_password" autocomplete="new-password" [type]="is_old_pass_type_password ? 'text' : 'password'" matInput [disabled]="is_passUpdating" placeholder="Confirm Password" aria-label="Custom Password">
                <mat-icon class="password-visbility-icon" matSuffix style="cursor: pointer" (click)="is_old_pass_type_password = !is_old_pass_type_password;">{{
                  is_old_pass_type_password ?
                  'visibility_off' :
                  'visibility'}}</mat-icon>
                <mat-error *ngIf="passConfirmationForm.controls['confirm_password'].invalid && (passConfirmationForm.controls['confirm_password'].dirty || passConfirmationForm.controls['confirm_password'].touched)">
                  <div *ngIf="passConfirmationForm.controls['confirm_password'].errors?.required">Please confirm your new Password</div>
                  <div *ngIf="passConfirmationForm.controls['confirm_password'].errors?.mismatch">Passwords do not match</div>
                </mat-error>
              </mat-form-field>
              <!-- <ng-container *ngIf="showValidationTxt"> -->
              <div class="pass-status d-flex flex-column mt-1">
                <div class="d-flex align-items-center">
                  <mat-icon *ngIf="passConfirmationForm.get('new_password').value.length >= 8 && passConfirmationForm.get('new_password').value.length <= 20; else unchecked" style="color:green">check_circle</mat-icon>
                  <span>Password must be between 8 and 20 characters.</span>
                </div>
                <div class="d-flex align-items-center">
                  <mat-icon *ngIf="newPasswordHasUppercase(); else unchecked" style="color:green">check_circle</mat-icon>
                  <span>Password must contain at least one uppercase letter.</span>
                </div>
                <div class="d-flex align-items-center">
                  <mat-icon *ngIf="newPasswordHasNumber(); else unchecked" style="color:green">check_circle</mat-icon>
                  <span>Password must contain at least one number.</span>
                </div>
                <ng-container *ngIf="policyType === 'strong'">
                  <div class="d-flex align-items-center">
                    <mat-icon *ngIf="newPasswordHasLowercase(); else unchecked" style="color:green">check_circle</mat-icon>
                    <span>Password must contain at least one lowercase letter.</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <mat-icon *ngIf="newPasswordHasSpecialChar(); else unchecked" style="color:green">check_circle</mat-icon>
                    <span>Password must contain at least one special character.</span>
                  </div>
                </ng-container>
                <!-- <div class="d-flex align-items-center">
                  <mat-icon *ngIf="((passConfirmationForm.get('new_password').value === passConfirmationForm.get('confirm_password').value) && passConfirmationForm.get('new_password').value && passConfirmationForm.get('confirm_password').value && selectedIndex == 2); else unchecked" style="color:green">check_circle</mat-icon>
                  <span>Password Confirmed.</span>
                </div> -->
              </div>
            <!-- </ng-container> -->
              <div class="mt-4 d-flex justify-content-center flex-column align-items-center" [ngClass]="update_pass_error_msg != '' ? '' : 'pt-3'">
                <small *ngIf="update_pass_error_msg != ''" class="form-error-msg-text" [innerHTML]="update_pass_error_msg"></small>
                <button mat-flat-button color="primary" class="change-pass-btn" *ngIf="!is_passUpdating" (click)="changePassword()" [style.margin-top]="update_pass_error_msg != '' ? '1rem' : '0'">
                  {{is_from_verify_account ? 'Set' : 'Change'}} Password
                </button>
                <mat-icon *ngIf="is_passUpdating"><mat-spinner diameter="24"></mat-spinner></mat-icon>
              </div>
            </form>
          </ng-container>
        </mat-tab>
      </mat-tab-group>
    </div>

    <div *ngIf="!is_from_verify_account">
      <mat-divider></mat-divider>
      <div class="text-center">
        <a class="tab-change-link" (click)="getLoginPageTab()">Log in</a>
      </div>
    </div>
  </div>
</ng-container>


<ng-template #successMsg>
  <div class="pt-5 mt-4 w-100 d-flex justify-content-center">
    <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
     <circle class="checkmark__circle" cx="26" cy="26" r="25"/>
     <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
    </svg>
  </div>
  <div class="pt-4 pb-5 pass-success-container d-flex justify-content-center text-center align-items-center">
    Password Updated Successfully!
  </div>
</ng-template>

<ng-template #unchecked>
  <mat-icon style="color:crimson" matTooltipPosition="right">remove_circle</mat-icon>
</ng-template>
